$(document).ready(function () {
    if (!$("#tariff-add-ons-container").length) {
        return;
    }

    $(document).on("click", ".more-info", function () {
        $(".popup")
            .removeClass("more-info-popup-open-left", "more-info-popup-close")
            .addClass("more-info-popup-close");

        let popup = $(this).parents(".single-card-intro").siblings(".popup");

        $("body").off("click");
        setTimeout(function () {
            $("body")
                .not(".popup")
                .on("click", function (e) {
                    $(popup).attr("class", "more-info-popup-close popup");
                });
        }, 500);

        if ($(popup).data("index") == 3) {
            $(popup).addClass("more-info-popup-open-left");
        } else {
            $(popup).addClass("more-info-popup-open");
        }
        $(popup).removeClass("more-info-popup-close");
    });

    $(".close-popup").on("click", function (e) {
        $(".popup")
            .removeClass("more-info-popup-open-left", "more-info-popup-close")
            .addClass("more-info-popup-close");
    });

    $slickchooseus = false;

    function chooseus_Slider() {
        if ($(window).width() < 1250) {
            if (!$slickchooseus) {
                $(".cards-section").slick({
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                    centerMode: false,
                    centerPadding: "60px",
                    infinite: false,
                    slidesToShow: 2,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: "40px",
                                slidesToShow: 1,
                            },
                        },
                    ],
                });
                $slickchooseus = true;
            }
        } else if ($(window).width() > 1249) {
            if ($slickchooseus) {
                $(".cards-section").slick("unslick");
                $slickchooseus = false;
            }
        }
    }

    $(function () {
        chooseus_Slider();
        $(window).resize(function () {
            chooseus_Slider();
        });
    });
});
